var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.73684L15.7895 8.94737V5.26316C15.7895 4.63158 15.3684 4.21053 14.7368 4.21053H8.21053L20 16V4.73684ZM1.36842 0L0 1.36842L2.84211 4.21053H2.10526C1.47368 4.21053 1.05263 4.63158 1.05263 5.26316V15.7895C1.05263 16.4211 1.47368 16.8421 2.10526 16.8421H14.7368C14.9474 16.8421 15.1579 16.7368 15.2632 16.6316L18.6316 20L20 18.6316L1.36842 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMute);
export default __webpack_public_path__ + "static/media/video-mute.c35c9b5a9488b2d5f0d04e65abedb26e.svg";
export { ForwardRef as ReactComponent };